import { KeyValuePair } from "../../commonInterfaces";
import { EditableGrid, field, InGridButtonClickParams, InGridToolBarButton, Schema } from "../../core/components/editableGrid/editableGrid";
import { Helper } from "../../core/util/helper";
import React from "react";

export default class IngridRights extends React.Component<IngridRightsProps, any>{
    private rights: KeyValuePair<any, string>[] = []
    private gridOptions;
    constructor(props: IngridRightsProps) {
        super(props)
        this.rights = props.field.rights;
        this.setOptions();
    }

    private setOptions = () => {
        this.gridOptions = {
            columns: [
                {
                    type: "textBox",
                    field: this.props.field.field,
                    title: this.props.field.fieldName,
                    width: 250,
                    readonly: true
                },
                {
                    type: "dropDown",
                    field: "Recht",
                    title: Helper.getTranslation("Statistik.Recht"),
                    width: 250,
                    template: (item: Right) => {
                        let right = this.rights.find(r => r.Key == item.Recht);
                        if (!Helper.hasValue(right)) {
                            right = this.rights.find(r => r.Key == 0);
                        }
                        return right.Value ?? right.Key;
                    },
                    dataSource: "rights",
                    dataTextField: "Value",
                    dataValueField: "Key",
                    optionLabel: "",
                    filterable: {
                       ui: this.filter
                    }
                }
            ]
        };
    }

    private filter = (element: any) => {
        element.kendoDropDownList({
            dataTextField: "Value",
            dataValueField: "Key",
            dataSource: this.rights,
            optionLabel: Helper.getTranslation("Standard.BitteWählen")
        });
    }

    private onValueChange = (action, fieldName, dataItems) => {
        if (action != "itemchange" || fieldName != "Recht")
            return;
        let data: Right[] = this.props.value;
        const index = data.findIndex(f => f[this.props.field.id] == dataItems[0][this.props.field.id])
        data[index].Recht = dataItems[0].Recht
        this.props.onChange(this.props.field, data, data)
    }

    render() {
        let schema = new Schema();
        schema.Id = this.props.field.id;

        const whatever: any = {
            ...this.props, 
            dataSources: {
                rights: this.rights
            }
        };

        return (
            <div style={{ height: "500px" }}>
                <EditableGrid data={this.props.value}
                    id={"mainGroupRights_" + this.props.field.field}
                    schema={schema}
                    gridOptions={this.gridOptions}
                    editable={!this.props.entity.UserHasRole}
                    onDataChanged={this.onValueChange}
                    validatable={false}
                    showSelectableCheckBox={false}
                    groupable={false}
                    filterable={true}
                    {...whatever}
                />
            </div>
        )
    }
}

interface IngridRightsProps {
    value: Right[];
    onChange: (field, value, dataItem) => void;
    entity: { UserHasRole: boolean };
    field: {
        rights: KeyValuePair<number, string>[];
        id: string;
        fieldName: string;
        field: string;
    };
}

interface Right {
    Language: number;
    Name: string;
    Recht: any;
}